import React from "react";
import { Link } from "react-router-dom";
import attachmentsIcon from "../../images/icons/svg/attachments-icon.svg";
import commentsIcon from "../../images/icons/svg/comment-icon.svg";
import referenceIcon from "../../images/icons/svg/reference-icon.svg";
import versionsIcon from "../../images/icons/svg/versions-icon.svg";
import shareLinkIcon from "../../images/icons/svg/share-link-icon.svg";
import attachmentsIconGreen from "../../images/icons/svg/attachments-icon-green.svg";
import commentsIconGreen from "../../images/icons/svg/comment-icon-green.svg";
import referenceIconGreen from "../../images/icons/svg/reference-icon-green.svg";
import versionsIconGreen from "../../images/icons/svg/versions-icon-green.svg";
import shareLinkIconGreen from "../../images/icons/svg/share-link-icon-teal.svg";
import claimsIcon from "../../images/icons/svg/claims-icon.svg";
import claimsIconGreen from "../../images/icons/svg/claims-icon-green.svg";
import templateIcon from "../../images/icons/svg/template-icon-grey.svg";
import templateIconGreen from "../../images/icons/svg/template-icon-green.svg";

import styles from "./SidePanelSection.module.scss";

export default (props) => {
  const {
    clickAction,
    count,
    type,
    paigeReviewStatus,
    criticalCount,
    warningCount,
    infoCount,
    fileTypeLabel,
  } = props;

  let title;
  let icon;
  let greenIcon;
  let sectionId;
  if (type === "references") {
    title = "References";
    icon = referenceIcon;
    greenIcon = referenceIconGreen;
    sectionId = "reference-icon";
  } else if (type === "attachments") {
    title = "Attachments";
    icon = attachmentsIcon;
    greenIcon = attachmentsIconGreen;
    sectionId = "attachments-icon";
  } else if (type === "versions") {
    title = "Version History";
    icon = versionsIcon;
    greenIcon = versionsIconGreen;
    sectionId = "versions-icon";
  } else if (type === "comments") {
    title = "Comments";
    icon = commentsIcon;
    greenIcon = commentsIconGreen;
    sectionId = "comments-icon";
  } else if (type === "share_link") {
    title = "Share Links";
    icon = shareLinkIcon;
    greenIcon = shareLinkIconGreen;
    sectionId = "share-link-icon";
  } else if (type === "claims") {
    title = "Product Claims";
    icon = claimsIcon;
    greenIcon = claimsIconGreen;
    sectionId = "claims-icon";
  } else if (type === "editor") {
    title = "Edit";
    icon = templateIcon;
    greenIcon = templateIconGreen;
    sectionId = "template-icon";
  } else if (type === "paige_translations") {
    title = "Translations";
    icon = claimsIcon;
    greenIcon = claimsIconGreen;
    sectionId = "paige-translations-icon";
  } else if (type === "chats") {
    title = "Ask Paige";
    icon = claimsIcon;
    greenIcon = claimsIconGreen;
    sectionId = "paige-chat-icon";
  } else if (type === "paige_review") {
    title = "Paige Review";
    icon = claimsIcon;
    greenIcon = claimsIconGreen;
    sectionId = "paige-chat-icon";
  }

  return (
    <div className={styles.sectionContainer} id={type}>
      <div
        className={
          props.showMobileSidePanel
            ? styles.mobileSidePanelOptions
            : styles.sidePanelOptions
        }
      >
        <Link className={styles.approvalsLink} to={"#"} onClick={clickAction}>
          <div className={styles.approvals}>
            <span className={styles.iconWrapper}>
              <img
                id={sectionId}
                className={styles.icon + " " + styles.iconDefault}
                src={icon}
              />
              <img
                className={styles.icon + " " + styles.iconHover}
                src={greenIcon}
              />
            </span>
            {(type === "paige_translations" ||
              type === "chats" ||
              type === "paige_review") && (
              <span className={styles.paigeSidePanelLabel}>{title}</span>
            )}
            {type !== "paige_translations" &&
              type !== "chats" &&
              type !== "paige_review" && <span>{title}</span>}
          </div>
          {type === "paige_review" && (
            <div className={styles.paigeReviewCounts}>
              {(paigeReviewStatus === "pending" ||
                paigeReviewStatus === "processing") && (
                <span className={styles.processingBadge}>Processing...</span>
              )}
              {paigeReviewStatus === "completed" && (
                <>
                  {criticalCount > 0 && (
                    <span className={styles.criticalBadge}>
                      {criticalCount}
                    </span>
                  )}
                  {warningCount > 0 && (
                    <span className={styles.warningBadge}>{warningCount}</span>
                  )}
                  {infoCount > 0 && (
                    <span className={styles.infoBadge}>{infoCount}</span>
                  )}
                </>
              )}
              {paigeReviewStatus === "failed" && (
                <span className={styles.failedBadge}>Failed</span>
              )}
            </div>
          )}
          {type !== "editor" && type !== "paige_review" && (
            <div className={styles.approvalsRemaining}>
              <span id="versions__number-attachments">{count}</span>
            </div>
          )}
          {type === "editor" && fileTypeLabel && (
            <span
              className={
                styles.fileTypeBadge +
                " " +
                styles["fileTypeBadge" + fileTypeLabel]
              }
            >
              {fileTypeLabel}
            </span>
          )}
          <div className="clear" />
        </Link>
      </div>
    </div>
  );
};
